module.exports = {
          srcSet: __webpack_public_path__ + "cfca1b60d45cdc9a3fde051ff7dc526c-1920.png"+" 1920w",
          images:[ {path: __webpack_public_path__ + "cfca1b60d45cdc9a3fde051ff7dc526c-1920.png",width: 1920,height: 731}],
          src: __webpack_public_path__ + "cfca1b60d45cdc9a3fde051ff7dc526c-1920.png",
          toString:function(){return __webpack_public_path__ + "cfca1b60d45cdc9a3fde051ff7dc526c-1920.png"},
          
          width: 1920,
          height: 731
        }